import './_navigation-footer.scss';

export default () => {};
